import simbApi from ".";
import { ADD_ITEM_LOCATIONS_COLUMN } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export const addItemLocationsColumn = async (access_token: string, boardId: number) => {
  try {
    const response = await simbApi.post(
      ADD_ITEM_LOCATIONS_COLUMN,
      { boardid: boardId },
      {
        headers: { Authorization: `Bearer ${access_token}` },
        timeout: 0, // Disable timeout for this request
      }
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response;
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};
